
export default class Selection {
  constructor(api) {
    this.api = api
  }

  set(xml) {
    return this.api.call_busy({
      '_class': 'Selection',
      '_method': 'set',
      'xml': xml
    })
  }

  delete(xml, delAccount) {
    return this.api.call_busy({
      '_class': 'Selection',
      '_method': 'delete',
      'xml': xml,
      'delete_account' : delAccount
    })
  }
  
  export(xml) {
    this.api.simple_post({
      '_class': 'Selection',
      '_method': 'export',
      'xml': xml
    })
  }

}
